import React from 'react';
import { Link } from "react-router-dom";

import ListButton from './listButton.js'
import Pagination from './pagination.js'
import SectionHeader from './sectionHeader.js'
import TechnologyIconAndName from './technologyIconAndName.js' 
import VersionRef from './versionRef.js' 

import { _printShortDate } from '../helpers/helpers.js'

import {TechnologyChangeData, TechnologyChangesSection} from '../../../server/routes/website.js'


interface DomainHistoryProps {
    technologyChanges: TechnologyChangesSection;
    link?: string;
}


export default function DomainHistory({ technologyChanges, link }: DomainHistoryProps) {

    if (!technologyChanges.Changes) return null;
    if (!technologyChanges.Changes.length) return null;

    return (<>

        <div className="row row-50">
            <div className="col-12">
                <SectionHeader header={technologyChanges.Header} link={link} anchor='history' />
                <div className="table-outer table-rounded table-responsive-lg">
                    <table className="table-custom table-custom-striped table-custom-primary">
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}>Technology</th>
                                <th style={{ width: '20%' }}>Technology Type</th>
                                <th style={{ width: '10%' }}>Version</th>
                                <th style={{ width: '25%' }}>Change</th>
                                <th style={{ width: '15%' }}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                technologyChanges.Changes.map((technologyChange, indexKey) => {
                                    return (
                                        <TechnologyChange technologyChange={technologyChange} key={indexKey}/>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <Pagination pages={technologyChanges.Pages} />
                <ListButton button={technologyChanges.Button} />
            </div>
        </div>
    </>)
}

function TechnologyChange({ technologyChange }: { technologyChange: TechnologyChangeData }) {

    return (

        <tr>
            <td>
                <TechnologyIconAndName 
                    technology={technologyChange.Technology}
                    technologyURL={technologyChange.TechnologyURL}
                    technologyIcon={technologyChange.TechnologyIcon}
                    title={`${technologyChange.Technology} customers list, historic trends, and recent website additions`}
                />
            </td>

            <td>
                <Link 
                    to={`/technology-type/${technologyChange.CategoryURL}`}
                    className="link-hover" 
                    title={`${technologyChange.Category} category market share and usage statistic`} 
                >
                    {technologyChange.Category}
                </Link>
            </td>                                   
            <td>
                <VersionRef 
                    technology= {{
                        TechnologyURL:technologyChange.TechnologyURL,
                        Technology:technologyChange.Technology,
                        Version:technologyChange.VersionTo
                }}/>
            </td>   
           
            <td>
                {
                    !!technologyChange.Added &&
                    <>
                        <i className="fa fa-plus" style={{ color: 'green' }} title="Technology Added"></i>
                        &nbsp;Added
                    </>
                }
                {
                    !!technologyChange.VersionChange &&
                    <>
                        <i className="fa fa-refresh" style={{ color: 'blue' }} title="Version Changed"> </i>
                       {' '}Upgrade from{' '} 
                        {
                            technologyChange.VersionFrom ?
                                <VersionRef 
                                    technology= {{
                                        TechnologyURL:technologyChange.TechnologyURL,
                                        Technology:technologyChange.Technology,
                                        Version:technologyChange.VersionFrom
                                    }}
                                />:
                                <>
                                    'unknown'
                                </>
                        }
                        {' '} to {' '} 
                        {
                            technologyChange.VersionTo ?
                            <VersionRef 
                                technology= {{
                                    TechnologyURL:technologyChange.TechnologyURL,
                                    Technology:technologyChange.Technology,
                                    Version:technologyChange.VersionTo
                                }}
                            />:
                            <>
                                'unknown'
                            </>
                        }
                    </>                
                }                
                {
                    !!technologyChange.Dropped &&
                    <>
                        <i className="fa fa-minus" style={{ color: 'red' }} title="Technology Dropped"></i>
                        &nbsp;Dropped
                    </>
                }

                {
                    !!technologyChange.InitialDetection &&
                    <>
                        <i className="fa fa-circle" style={{ color: 'green' }} title="Initial Detection"> </i>
                        &nbsp;Initial Detection
                    </>
                }
            </td>
            <td>
                {_printShortDate(technologyChange.Date)}
            </td>
        </tr>
    )
}
